import React from 'react';
import { Link } from 'react-router-dom';
import { FALLBACK_IMAGE, imageFallback } from '../lib/imageUtils';

const Hero = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={FALLBACK_IMAGE}
          alt="Luxury Diamond Necklace"
          onError={imageFallback}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/60 to-transparent"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
        <div className="md:col-span-7 space-y-8">
          <div className="space-y-4">
            <p className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] font-light" data-testid="hero-subtitle">
              Timeless Elegance
            </p>
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-light leading-tight tracking-tighter text-white" data-testid="hero-title">
              Crafted for
              <br />
              <span className="text-[#D4AF37]">Eternity</span>
            </h1>
          </div>

          <p className="text-lg text-[#A3A3A3] max-w-xl leading-relaxed font-light" data-testid="hero-description">
            Discover our collection of handcrafted jewelry pieces, each telling a unique story of artistry and refined beauty.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 pt-4">
            <Link
              to="/products"
              className="px-10 py-4 bg-[#D4AF37] text-black font-medium tracking-wide uppercase text-sm hover:bg-[#F1E5AC] transition-all duration-300 text-center"
              data-testid="hero-shop-button"
            >
              Explore Collection
            </Link>
            <Link
              to="/products?featured=true"
              className="px-10 py-4 bg-transparent text-white border border-white/20 hover:border-white font-medium tracking-wide uppercase text-sm transition-all duration-300 text-center"
              data-testid="hero-featured-button"
            >
              Featured Pieces
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-white/50 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
